export class TransportesModel {
  id_transporte: number;
  nome: string;
  tipo: string = 'm'; // maritimo
}



// WEBPACK FOOTER //
// ./src/app/transportes/transportes.model.ts